import { ElementId, PathSegment, TrackingData } from '../types';
import { parseElementId } from './element-id';

export function parseTrackData(el: HTMLElement): TrackingData {
  const data: TrackingData = {};
  for (const [key, value] of Object.entries(el.dataset)) {
    if (value !== undefined && key.startsWith('trackData') && key.length > 9) {
      const dataKey = key[9].toLowerCase() + key.slice(10);
      data[dataKey] = value;
    }
  }
  return data;
}

export function collectDomScopes(
  element: HTMLElement,
  stopAt?: HTMLElement,
): {
  scopes: PathSegment[];
  data: TrackingData;
} {
  const scopes: PathSegment[] = [];
  const dataLayers: TrackingData[] = [];

  let walker = element.parentElement;
  while (walker && walker !== stopAt) {
    const layerData = parseTrackData(walker);
    if (Object.keys(layerData).length > 0) {
      dataLayers.unshift(layerData);
    }
    if (walker.dataset.trackScope) {
      scopes.unshift(parseElementId(walker.dataset.trackScope as ElementId));
    }
    walker = walker.parentElement;
  }

  return {
    scopes,
    data: Object.assign({}, ...dataLayers),
  };
}
